// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_2fXYrMINwc3qqxBAwugu03","container":"_3pHj5Gi8gVL4xgJBeJN-M8","logo":"_2AOgnoZyJ_NLvvDemxGJw1","largeHeader":"_1ok-PJAtafwbF0F0t6nP_X","containerMobile":"_3aZRLYEJ-P6uG4WmMLvDFQ","hidden":"_2gmUGtD8Juy5wCr0x2Ixen"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Header/Header.css
// module id = 1130
// module chunks = 58